"use client";

import type { CommunityActivityFeedReferenceType } from "../../../../lib/types/enums/community/communityActivityFeedReferenceTypeEnum";
import type { CommunityActivityFeed } from "../../../../lib/types/schema/community/activityFeed/communityActivityFeed";
import { communityActivityFeedSchema } from "../../../../lib/types/schema/community/activityFeed/communityActivityFeed";
import type { UseRequestInfiniteQueryProps } from "../../../../request/hooks/useRequestInfiniteQuery";
import { useRequestInfiniteQuery } from "../../../../request/hooks/useRequestInfiniteQuery";
import { keyCommunityActivityFeed } from "./keyCommunityActivityFeed";

export type UseRequestCommunityActivityFeedProps =
  UseRequestInfiniteQueryProps & {
    id: number;
    types?: CommunityActivityFeedReferenceType[];
  };

export const useRequestCommunityActivityFeed = ({
  id,
  types,
  ...props
}: UseRequestCommunityActivityFeedProps) => ({
  infiniteQuery: useRequestInfiniteQuery({
    getNextPageParam: (lastPage: CommunityActivityFeed) =>
      lastPage?.results[lastPage?.results?.length - 1]?.id || null,
    initialPageParam: -1,
    ...props,
    queryFnRequestProps: ({ pageParam }) => {
      const searchParams = new URLSearchParams("?per_page=10");
      if (pageParam && pageParam !== -1)
        searchParams.set("last_id", pageParam as string);
      if (types?.length) {
        for (const type of types) searchParams.append("post_types[]", type);
      }

      return {
        schema: communityActivityFeedSchema,
        urlBackendPath: `/me/communities/${id}/activity-feed${searchParams.toString().length > 0 ? `?${searchParams.toString()}` : ""}`,
      };
    },
    queryKey: keyCommunityActivityFeed({ id, types }),
  }),
});
